export default "__VITE_ASSET__cc9d44bb__"